import AuthRequests from '../../server/auth';
import AuthService from '../../services/auth';
import AdmMenusAction from './admMenu';

import { addLoading, removeLoading } from './loading';

export const resetAuthentication = () => ({
  type: 'LOGOUT',
});

export const saveUser = user => ({
  type: 'SAVE_USER',
  user,
});

export const saveAuthentication = authData => ({
  type: 'LOGIN',
  auth: authData,
});

export const cleanAuth = () => async (dispatch) => {
  dispatch(resetAuthentication());
  AuthService.reset();
};

export const getUser = () => async (dispatch) => {
  dispatch(addLoading());

  try {
    const user = await AuthRequests.getUser();
    await dispatch(AdmMenusAction.getAdmMenuRoutes(user.id, user.profileId));
    await dispatch(AdmMenusAction.getAdmMenuTree(user.id, user.profileId));
    dispatch(saveUser(user));
  } catch (err) {
    dispatch(cleanAuth());
  } finally {
    dispatch(removeLoading());
  }
};

export const authenticate = (email, password, reCaptchaVerify) => async (dispatch) => {
  dispatch(addLoading());

  try {
    const auth = await AuthRequests.authenticate(email, password, reCaptchaVerify);
    AuthService.create(auth);
    dispatch(saveAuthentication(auth));
    await dispatch(getUser());
  } finally {
    dispatch(removeLoading());
  }
};

export const refreshToken = token => async (dispatch) => {
  const auth = await AuthRequests.refreshToken(token);
  AuthService.create(auth);
  dispatch(saveAuthentication(auth));
};

export const logout = () => async (dispatch) => {
  dispatch(addLoading());

  try {
    await AuthRequests.logout();
  } finally {
    dispatch(cleanAuth());
    dispatch(removeLoading());
  }
};
